import 'regenerator-runtime/runtime';
import { put, call, takeEvery, takeLatest, all } from 'redux-saga/effects';
import { AppSettings } from '../constants';
import * as TradeActionType from './constants';
import * as NotifyActionType from 'Notification/constants';
import { sendAjaxRequest } from '../helper/interceptors';
import { ObjToParam } from '../helper/helper-api';
const portal = AppSettings.clientTypeValue
  ? AppSettings.clientTypeValue.toLowerCase()
  : '';

export function* getByIdAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.GLOBAL_API_URL,
    `/apiv1/trades/${action.payload.params}`,
    {}
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: TradeActionType.GET_TRADE_BY_ID_SUCCESS,
      data: result.data,
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchTradeAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.GLOBAL_API_URL,
    '/apiv1/trades/search',
    action.payload.params
  );

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: TradeActionType.SEARCH_TRADE_SUCCESS,
      data: {
        data: result.data,
        params: action.payload.params,
      },
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* createTradeAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.GLOBAL_API_URL,
    '/apiv1/trades',
    action.payload,
    'POST'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: TradeActionType.SEARCH_TRADE_ASYNC,
        payload: { params: action.payload.search },
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Trade created' }),
    ];
  } else {
    yield put({
      type: TradeActionType.ADD_EDIT_TRADE_ERROR,
      data: { error: result.data, params: action.payload },
    });
  }
}

export function* updateTradeAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.GLOBAL_API_URL,
    '/apiv1/trades',
    action.payload,
    'PUT'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: TradeActionType.SEARCH_TRADE_ASYNC,
        payload: { params: action.payload.search },
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' }),
    ];
  } else {
    yield put({
      type: TradeActionType.ADD_EDIT_TRADE_ERROR,
      data: { error: result.data, params: action.payload },
    });
  }
}

export function* makeActiveAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.GLOBAL_API_URL,
    `/apiv1/trades/${action.payload.data}/active`,
    {},
    'PUT'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: TradeActionType.SEARCH_TRADE_ASYNC,
        payload: { params: action.payload.search },
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' }),
    ];
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { data: result.data },
    });
  }
}

export function* makeInActiveAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.GLOBAL_API_URL,
    `/apiv1/trades/${action.payload.data}/inactive`,
    {},
    'PUT'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: TradeActionType.SEARCH_TRADE_ASYNC,
        payload: { params: action.payload.search },
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' }),
    ];
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { data: result.data },
    });
  }
}

export function* selectListItemTradeAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/trades/trades-select-list',
    action.params.param
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    let actionTypes = processAfterSuccess(action, result);

    yield [actionTypes];
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { data: result.data },
    });
  }
}

export function* selectListTradeAsync(action) {
  let result = null;
  if (portal === 'builder') {
    result = yield call(
      sendAjaxRequest,
      AppSettings.CURRENT_SITE_URI,
      '/api/trades/trades-select-list',
      action.params,
      'GET',
      false
    );
  }
  if (portal === 'system') {
    result = yield call(
      sendAjaxRequest,
      AppSettings.GLOBAL_API_URL,
      '/apiv1/trades/select-list-items',
      action.params,
      'GET',
      false
    );
  }

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: TradeActionType.SELECT_LIST_TRADE_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { data: result.data },
    });
  }
}

export function* selectListTradeFromReportAsync(action) {
  let result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/reports/trade-select-list',
    action.params,
    'GET',
    false
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: TradeActionType.SELECT_LIST_TRADE_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { data: result.data },
    });
  }
}

export function* selectListItemRepairAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    `/${action.params.id}/item-repair-select-list`,
    action.params,
    'GET',
    false
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { data: result.data },
    });
  }
}

export function* fetchListItemRepairForDefaultConfigAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    `/${action.params.id}/item-repair-select-list`,
    action.params,
    'GET',
    false
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: TradeActionType.FETCH_LIST_ITEM_REPAIR_BY_TRADEID_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { data: result.data },
    });
  }
}
export function* selectListTradeBySubcontractorIdAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.GLOBAL_API_URL,
    '/apiv1/subcontractors/select-list-trades',
    action.params,
    'GET',
    false
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: TradeActionType.SELECT_LIST_TRADE_BY_SUBCONTRACTOR_ID_SUCCESS,
      data: result.data,
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: { data: result.data },
    });
  }
}
export function* exportTradesListAsync(action) {
  // const result = yield call(exportProjectList, action.params);
  console.log('exportTradesListAsync', action.params);
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    `/api/projects/export?${ObjToParam(action.params)}`,
    'GET',
    false
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    //get file name
    let filename = 'trades.xlsx';
    let disposition = result.headers['content-disposition'];
    if (disposition) {
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(disposition);
      if (matches !== null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    let blob = new Blob([result.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    if (window.navigator.msSaveOrOpenBlob) {
      // for IE browser
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // for Non-IE (chrome, firefox etc.)
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}
export default function* WatchTrade() {
  yield all([
    takeLatest(TradeActionType.SEARCH_TRADE_ASYNC, searchTradeAsync),
    takeLatest(TradeActionType.GET_TRADE_BY_ID_ASYNC, getByIdAsync),
    takeEvery(TradeActionType.CREATE_TRADE_ASYNC, createTradeAsync),
    takeEvery(TradeActionType.UPDATE_TRADE_ASYNC, updateTradeAsync),
    takeEvery(TradeActionType.MAKE_ACTIVE_TRADE_ASYNC, makeActiveAsync),
    takeEvery(TradeActionType.MAKE_INACTIVE_TRADE_ASYNC, makeInActiveAsync),
    takeLatest(
      TradeActionType.SELECT_LIST_ITEM_TRADE_ASYNC,
      selectListItemTradeAsync
    ),
    takeLatest(TradeActionType.SELECT_LIST_TRADE_ASYNC, selectListTradeAsync),
    takeEvery(
      TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
      selectListItemRepairAsync
    ),
    takeEvery(
      TradeActionType.FETCH_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
      fetchListItemRepairForDefaultConfigAsync
    ),
    
    takeEvery(
      TradeActionType.SELECT_LIST_TRADE_FROM_REPORT_ASYNC,
      selectListTradeFromReportAsync
    ),
    takeLatest(
      TradeActionType.SELECT_LIST_TRADE_BY_SUBCONTRACTOR_ID_ASYNC,
      selectListTradeBySubcontractorIdAsync
    ),
    takeLatest(TradeActionType.EXPORT_TRADES_LIST, exportTradesListAsync),
  ]);
}

const processAfterSuccess = (action, result) => {
  var actionTypes = [];

  action.params.nextAction.forEach((item) => {
    if (item.params === null && typeof item.action !== 'undefined') {
      actionTypes.push(
        put({
          type: item.action,
          data: result.data,
          internalParams: item['internalParams'],
        })
      );
    }

    if (item.params !== null && typeof item.action !== 'undefined') {
      actionTypes.push(put({ type: item.action, params: item.params }));
    }

    if (item.callBack) {
      item.callBack(result.data);
    }
  });

  return actionTypes;
};



// WEBPACK FOOTER //
// ./src/Trades/saga.js